import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {EnumTipoParametro} from '../enum/enum-tipo-parametro';
import {ClsParametro} from '../cls-parametros';
import {ClsErrores} from '../cls-errores';

export class ClsPeticionObtieneParametros extends ClsPeticionPresupuestos {
  Llave: bigint;
  TipoParametro: EnumTipoParametro;
  Parametro: ClsParametro[];
}

export class ClsPeticionGuardarActualizarParametros extends ClsPeticionPresupuestos {
  Parametro: ClsParametro[];
  TipoParametro: EnumTipoParametro;
}

export class ClsRespuestaParametros {
  Parametro: ClsParametro[];
  Errores: ClsErrores;
}
